<template>
  <div>
    <div class="mb-4 flex items-center">
      <h3 class="text-lg font-semibold uppercase tracking-wide text-primary">
        Device Uploads
      </h3>

      <hr class="mx-4 flex-1 border-primary" />
    </div>

    <div v-if="client && client.is_activated">
      <div class="mb-4 flex gap-4">
        <span
          v-for="category of categories"
          :key="category.key"
          class="flex items-center gap-2"
        >
          <RadioButton
            v-model="selectedCategory"
            :id="`radio-${category.key}`"
            name="category"
            :value="category.key"
            @change="onSelectedCategoryChanged"
          />
          <label :for="`radio-${category.key}`">
            {{ category.name }}
          </label>
        </span>
      </div>
  
      <spinner v-if="isLoading" :size="6" color="text-secondary" />
      <div v-else class="flex flex-col gap-2">
        <span v-if="!!error" class="text-red-600">{{ error }}</span>
        <vue-good-table
          v-if="uploads && uploads.length >= 0"
          styleClass="vgt-table condensed"
          :rows="uploads"
          :columns="columns"
          :pagination-options="{
            enabled: true,
            perPage: 10,
          }"
          :sort-options="{
            enabled: true,
            initialSortBy: { field: 'createdOn', type: 'desc' },
          }"
        >
          <template slot="table-row" slot-scope="props">
            <div v-if="props.column.field === 'accessUrl'">
              <a
                class="pi pi-download rounded mt-1 p-4 transition-colors duration-300 ease-in-out hover:bg-primary-highlight"
                :href="props.row[props.column.field]"
                target="_blank"
              />
            </div>
            <div v-else class="p-4">
              {{ props.formattedRow[props.column.field] }}
            </div>
          </template>
        </vue-good-table>
      </div>
    </div>
    <div v-else class="flex flex-wrap">
        <p class="mx-auto my-16">
          This client is not activated. Once activated, this panel will become available.
        </p>
      </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import Spinner from "@/components/Spinner.vue";
import prettyBytes from "pretty-bytes";

export default {
  name: "DeviceUploads",
  components: { Spinner, PageHeader },
  props: {
    client: Object,
  },
  data() {
    return {
      isLoading: false,
      uploads: [],
      columns: [
        { label: "File Name", field: "filename", sortable: true },
        {
          label: "Created On",
          field: "createdOn",
          type: "date",
          dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
          dateOutputFormat: "dd/MM/yyyy HH:mm:ss",
          width: "200px",
          sortable: true,
        },
        {
          label: "Last Modified",
          field: "lastModified",
          type: "date",
          dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
          dateOutputFormat: "dd/MM/yyyy HH:mm:ss",
          width: "200px",
          sortable: true,
        },
        {
          label: "File Size",
          field: "contentLength",
          width: "120px",
          type: "number",
          sortable: true,
          globalSearchDisabled: true,
          formatFn: (value) => prettyBytes(value),
        },
        {
          label: "",
          field: "accessUrl",
          width: "64px",
          sortable: false,
          globalSearchDisabled: true,
        },
      ],
      error: null,
      selectedCategory: "Backup",
      categories: [
        {
          key: "Backup/",
          name: "Backups",
        },
        {
          key: "crash/",
          name: "Crash Dumps",
        },
        {
          key: "logs/",
          name: "Logs",
        },
      ],
    };
  },
  async mounted() {
    this.selectedCategory= this.categories[0].key;
    await this.getUploads();
  },
  methods: {
    getUploads: async function () {
      this.isLoading = true;
      this.error = null;
      try {
        const result = await this.iVClientService.getDeviceUploads(this.client.client_id, this.selectedCategory);
        this.uploads = result || [];
      } 
      catch (error) {
        this.error = error;
        this.uploads = [];
      } 
      finally {
        this.isLoading = false;
      }
    },
    onSelectedCategoryChanged: async function () {
      await this.getUploads();
    },
  },
};
</script>
